'use strict';
import {getId, getLink} from '../../core-utilities/domain/ReduxUtils';
import * as TASK_TYPE from '../../tasks/enums/TASK_TYPE';
import {getAsset, getProject} from '../../app/model/reducers/state';


RequirementsFilesCreateController.$inject = [
  '$scope',
  '$modal',
  '$injector',
  '$miscUtils',
  '$toast',
  '$ngRedux',
  'task',
  'requirement',
  'ctrlConfig',
];

export function RequirementsFilesCreateController(
  $scope,
  $modal,
  $injector,
  $miscUtils,
  $toast,
  $ngRedux,
  task,
  existingRequirement,
  ctrlConfig,
) {
  const domainClass = $injector.get(ctrlConfig.domainClass);
  const vm = $scope.addReq = initViewModel(existingRequirement);

  vm.save = $miscUtils.blockPromise(save);
  vm.cancel = !existingRequirement ?
    $modal.cancel.bind($modal) :
    function revertAndClose() {
      vm.model.$revert();
      $modal.cancel();
    };


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/

  // TODO: need to handle edge cases where user first saves a asset level task then changes options and re-saves? (I don't think the view allows this right now)
  // TODO: need to disable save/(cancel?) button(s) once save is started and change it to a spinner
  function save() {
    if (!vm.model.$validate()) {
      console.warn(vm.model.$errors);
      return Promise.reject(vm.model.$errors);
    }

    if (existingRequirement) {
      return vm.model.update().then(function () {
        $modal.hide();
      });
    } else {
      return vm.model.create(vm.options)
        .then(function (newReq) {
          showSuccessMessage();
          if (newReq) {
            $modal.hide(newReq);
          } else {
            $modal.hide();
          }
        })
        .catch(function (error) {
          // TODO: show errors in view
          console.error(error);
        });
    }
  }

  function showSuccessMessage() {
    $toast.showI18nMessage({
      messageId: 'requirements.create.success.message',
      type: 'info',
    });
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/


  function initViewModel(requirement) {
    const rootState = $ngRedux.getState();
    const project = getProject(rootState);
    const asset = getAsset(rootState);
    const vm = {
      model: requirement,

      header: ctrlConfig.header,
      subheader: ctrlConfig.subheader,
    };


    if (!requirement) {
      vm.model = domainClass.$factory.create();
      vm.model.prj = getId(project);

      switch (ctrlConfig.taskType) {
        case TASK_TYPE.SITE:
          vm.model.assetTask = task;
          vm.model.ast = getId(asset);

          vm.options = {
            /* only show options if this is not a custom asset task */
            showProjectAssetTaskOptions: !!getLink(task, 'task').id,
            showAssetTaskOptions: !!getLink(task, 'task').id,

            /* create as Task and propagate to this AssetProject only */
            addToProject: false,

            /* create as Task and propagate to all existing AssetProjects */
            addToExisting: false,
          };
          break;
        case TASK_TYPE.PROJECT:
          vm.model.task = task;

          vm.options = {};
          break;
        case TASK_TYPE.PROJECT_SITE:
          vm.model.task = task;
          // TODO: add handling for project propagation options

          vm.options = {
            showProjectAssetTaskOptions: true,

            /* create as Task and propagate to all existing AssetProjects */
            addToExisting: true,

            /* TODO: status conditionals are not supported yet. options may need to modified once they are*/
            /* options that filter existing AssetProjects in some way */
            excludeComplete: false,
          };
          break;
      }
    }

    return vm;
  }
}



// WEBPACK FOOTER //
// ./src/js/requirements/modals/RequirementsFilesCreateController.js